import { useEffect, useState } from "react";
import { Loader } from "./components/Loader/Loader";
import RoutesConfig from "./routes/RoutesConfig";
import authService, { checkAndRenewToken } from "./services/authService";
import { Provider } from "react-redux";
import "./App.scss";
import store from "./redux/store";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "@mui/material";
import materialUITheme from "./Themes/materialUITheme";
import { useSnackBar } from "./hooks/useSnackBar";
import {
  subscribeToErrors,
  triggerExpSession,
} from "./services/axiosErrorListenerService";
import { useAlert } from "./hooks/useAlert";
import { AliveScope } from "react-activation";
import { NewPartRequestProvider } from "./modules/StoresModule/context/NewPartRequestContext";
import { GridStackProvider } from "./contexts/grid-stack-context";
import { ReduxLoader } from "./components/Loader/ReduxLoader";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://b9d83da8b2616b412ca1bdb734d27fcf@o4505755262189568.ingest.us.sentry.io/4508767360647168",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/terminus-develop.aspsols.com\.io\/api/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
function App() {
  const { errorMsg, successMsg, infoMsg, warningMsg } = useSnackBar();
  const [showExpSession, setShowExpSession] = useState(false);
  const { logOut } = authService();
  const { successAlert, errorAlert, infoAlert, warningAlert } = useAlert();

  const getCurrentPathName = () => {
    const path = window.location.pathname;
    if (path) {
      localStorage.setItem("path_pre_expiration", path);
    }
  };
  useEffect(() => {
    const unsubscribe = subscribeToErrors((message) => {
      if (message === true) {
        setShowExpSession(message);
        localStorage.removeItem("u_tk");
        warningAlert(
          "Alert Message",
          "Your session has expired. For security reasons, you need to log in again. Don’t worry , if you were working on a form, your data have been saved automatically.",
          {
            okClick: () => {
              logOut();
              // getCurrentPathName()
              setShowExpSession(false);
              window.location.href = "/login";
            },
            disableBackdrop: true,
          }
        );
      } else {
        errorAlert(
          "An unexpected error occurred",
          `An internal system error has occured. You can report this directly to the Service Desk so we can assist you as soon as possible. <br><br> <b>Technical Details (for support team):</b> <br>${message} `,
          {
            options: [
              {
                label: "Ok",
                onClick: () => {},
              },
            ],
          }
        );
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    // const handleFocus = () => checkAndRenewToken();
    // const handleReload = () => checkAndRenewToken();
    // window.addEventListener("focus", handleFocus);
    // window.addEventListener("load", handleReload);
    // return () => {
    //   window.removeEventListener("focus", handleFocus);
    //   window.removeEventListener("load", handleReload);
    // };
  }, []);

  return (
    <Provider store={store}>
      <GridStackProvider>
        <ThemeProvider theme={materialUITheme}>
          <Loader />
          {/* <ReduxLoader /> */}
          <NewPartRequestProvider>
            <RoutesConfig />
          </NewPartRequestProvider>
        </ThemeProvider>
      </GridStackProvider>
    </Provider>
  );
}

export default App;
